'use client';

import cx from 'classnames';
import { useMemo } from 'react';

import { EmptySearch } from '@/app/search/components/EmptySearch';
import { PreviewCard } from '@/components/PreviewCard';
import { Collection, CollectionContent } from '@/types/collection.types';
import { IItem } from '@/types/feed.types';

import { Spinner } from '../Spinner';
import styles from './ItemsGrid.module.scss';
import { IItemsGrid } from './ItemsGrid.types';

export const ItemsGrid: React.FC<IItemsGrid> = ({
  items,
  lastItemRef,
  isLoading = false,
  noResultsTitle,
  noResultsSubtitle,
  title,
  playlistId,
  collectionId,
  searchString,
  large = false,
  previewSource,
}) => {
  const PreviewCardProps = useMemo(
    () => ({
      playlistId,
      searchString,
      collectionId,
      previewSource,
    }),
    [playlistId, searchString, collectionId, previewSource],
  );

  if (!items.length && !isLoading) {
    return <EmptySearch title={noResultsTitle} subtitle={noResultsSubtitle} />;
  }

  return (
    <>
      {title && <h3 className={styles.title}>{title}</h3>}
      <div className={cx(styles.grid, { [styles.large]: large })}>
        {items.map(
          (item: IItem | Collection | CollectionContent, index: number) => {
            if (index + 1 === items.length) {
              return (
                <PreviewCard
                  innerRef={lastItemRef}
                  key={item?.id ?? index}
                  data={item}
                  {...PreviewCardProps}
                />
              );
            } else {
              return (
                <PreviewCard
                  key={item?.id ?? index}
                  data={item}
                  {...PreviewCardProps}
                />
              );
            }
          },
        )}
      </div>
      {isLoading && <Spinner />}
    </>
  );
};
